import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './RacingThemeSearchBannerTabs.module.css';

/**
 * Search banner channel tabs.
 */
const RacingThemeSearchBannerTabs = props => {
  const { tabs, activeTab, onTabChange } = props;

  return (
    <div className={styles.tabs} role="tablist" aria-label="Search channel">
      {tabs.map(tab => {
        const label = typeof tab === 'string' ? tab : tab.label;
        const id = typeof tab === 'string' ? tab : tab.id;
        const isActive = activeTab === id || activeTab === label;

        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={classNames(styles.tab, isActive && styles.tabActive)}
            onClick={() => {
              if (typeof onTabChange === 'function') {
                onTabChange(typeof tab === 'string' ? tab : tab);
              }
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

RacingThemeSearchBannerTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }),
    ])
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func,
};

export default RacingThemeSearchBannerTabs;
